import { createStore } from "vuex"

export default createStore({
  state: {
    repeatSlideNum: 1,
  },
  getters: {
    getRepeatSlideNum: (state) => () => {
      return state.repeatSlideNum
    },
  },
  mutations: {
    SET_REPEAT_SLIDE_NUM(state, data) {
      state.repeatSlideNum = data
    },
  },
  actions: {
    setRepeatSlideNum({ commit }, newValue) {
      commit("SET_REPEAT_SLIDE_NUM", newValue)
    },
  },
  modules: {},
})
